// ==========================================
// SubCategoryModel.js
// ==========================================
export class SubCategoryModel {
  static ALLOWED_KEYS = Object.freeze([
    "id",
    "subCategoryId",
    "subCategoryName",
    "categoryId",
    "serializationType",
    "depreciation",
    "usefulLife",
    "depreciationRate",
    "description",
    "status",
    "companyId",
    "company",
    "taggingRequired",
    "metadata",
  ]);

  static ALLOWED_METADATA_KEYS = Object.freeze([
    "createdAt",
    "createdBy",
    "updatedAt",
    "updatedBy",
    "deletedFlag",
  ]);

  static ID_FIELD = "subCategoryId";
  static NAME_FIELD = "subCategoryName";

  constructor(data = {}, { isCreation = false } = {}) {
    for (const key of SubCategoryModel.ALLOWED_KEYS) {
      if (key === "metadata") {
        this.metadata = {
          createdAt: null,
          createdBy: null,
          updatedAt: null,
          updatedBy: null,
          deletedFlag: false,
        };
      } else if (key === "status") {
        this.status = "active";
      } else if (key === "serializationType") {
        this.serializationType = "serialized";
    } else if (key === "depreciation") {
        this.depreciation = "";
      } else if (key === "taggingRequired") {
        this.taggingRequired = false;   
      } else {
        this[key] = null;
      }
    }

    if (isCreation) {
      this.id = data.id || crypto.randomUUID();
      this.subCategoryId = data.subCategoryId || null;
      this.subCategoryName = data.subCategoryName || null;
      this.categoryId = data.categoryId || null;
      this.serializationType = data.serializationType || "serialized";
      this.depreciation = data.depreciation || "";
      this.usefulLife = data.usefulLife ?? null;
      this.depreciationRate = data.depreciationRate ?? null;
      this.description = data.description || null;
      this.status = data.status || "active";
      this.companyId = data.companyId || null;
      this.company = data.company || null;
      this.taggingRequired =
  data.taggingRequired === true ||
  data.taggingRequired === "true" ||
  String(data.taggingRequired || "").toLowerCase() === "yes";
      const now = new Date().toISOString();
      this.metadata = {
        createdAt: data.metadata?.createdAt || data.createdAt || now,
        createdBy: data.metadata?.createdBy || data.createdBy || "system",
        updatedAt: data.metadata?.updatedAt || data.updatedAt || now,
        updatedBy: data.metadata?.updatedBy || data.updatedBy || "system",
        deletedFlag: data.metadata?.deletedFlag ?? false,
      };
    } else {
      for (const key of Object.keys(data)) {
        if (!SubCategoryModel.ALLOWED_KEYS.includes(key)) continue;

        if (key === "metadata") {
          this.metadata = { ...this.metadata, ...(data.metadata || {}) };
       } else if (key === "taggingRequired") {
  this.taggingRequired =
    data.taggingRequired === true ||
    data.taggingRequired === "true" ||
    String(data.taggingRequired || "").toLowerCase() === "yes";
} else {
  this[key] = data[key];
}
      }
      if (data.createdAt) this.metadata.createdAt = data.createdAt;
      if (data.createdBy) this.metadata.createdBy = data.createdBy;
      if (data.updatedAt) this.metadata.updatedAt = data.updatedAt;
      if (data.updatedBy) this.metadata.updatedBy = data.updatedBy;
    }
  }

  isValid() {
    if (!this.subCategoryName || !String(this.subCategoryName).trim()) return false;
    if (!this.subCategoryId || !String(this.subCategoryId).trim()) return false;
    if (!this.categoryId) return false;
    return true;
  }

  toPayload() {
    const payload = {};
    for (const key of SubCategoryModel.ALLOWED_KEYS) {
      if (key === "metadata") {
        payload.metadata = {};
        for (const mk of SubCategoryModel.ALLOWED_METADATA_KEYS) {
          payload.metadata[mk] = this.metadata?.[mk] ?? (mk === "deletedFlag" ? false : null);
        }
      } else if (this[key] !== undefined) {
        payload[key] = this[key];
      }
    }
    return payload;
  }

  toJSON() {
    return this.toPayload();
  }
}
